"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const r=(e,t)=>e.filter((n,o)=>o!==t);exports.removeAtIndex=r;
